<template>
  <el-row style="padding-bottom: 20px">
    <!-- 标题 -->
    <el-col class="page-head">
      <el-col class="head-title">{{ title }}</el-col>
    </el-col>
    <!-- 链接列表 -->
    <el-col class="common-block">
      <el-col
        :span="8"
        v-for="(item, index) in linkList"
        :key="index"
        class="link-item"
        @click.native="toLinkPage(item)"
      >
        <!-- 常用链接 -->
        <el-col v-if="type == 1">
          <el-row justify="center" align="center">
            <el-col :span="8" class="common-link-item-icon">
              <img
                style="width: 100%; height: 100%"
                :src="imgserver + item.icon"
              />
            </el-col>
            <el-col :span="6" class="common-link-item-name">
              {{ item.name }}
            </el-col>
          </el-row>
        </el-col>
        <!-- 友情链接 -->
        <el-col v-if="type == 2">
          <el-row justify="center" align="center">
            <el-col :span="24" class="friendship-link-item-icon">
              <img
                style="width: 100%; height: 100%"
                :src="imgserver + item.picUrl"
              />
            </el-col>
          </el-row>
        </el-col>
        <!-- 专业部系介绍 -->
        <el-col v-if="type == 3">
          <el-row justify="center" align="center">
            <el-col :span="24" class="introduce-link-item-icon">
              <img
                style="width: 100%; height: 100%"
                :src="imgserver + item.picUrl"
              />
            </el-col>
          </el-row>
        </el-col>
      </el-col>
    </el-col>
  </el-row>
</template>

<script>
import {
  getHomeFriendLinksListApi,
  getHomeHonorListApi,
  getHomeOftenLinksListApi,
} from "@/api/homeApi";
import shareMethods from "@/common/shareMethods";
export default {
  name: "home",
  components: {},
  data() {
    return {
      title: "",
      type: 0,
      linkList: [],
    };
  },
  mixins: [shareMethods],
  created() {

    let imgUrl = "https://www.csysedu.com/favicon.png";
    let linkUrl = window.location.href ;
    let desc = "长沙市唯上商务科技学校";
    let title = "长沙市唯上商务科技学校";
    this.share(imgUrl, linkUrl,desc, title );

    if (this.$route.query.type && this.$route.query.type == 1) {
      this.title = "常用链接";
      this.type = 1;
      getHomeOftenLinksListApi().then((res) => {
        this.linkList = res.rows;
      });
    } else if (this.$route.query.type == 2) {
      this.title = "友情链接";
      this.type = 2;
      getHomeFriendLinksListApi().then((res) => {
        this.linkList = res.rows;
      });
    } else if (this.$route.query.type == 3) {
      this.title = "专业部系介绍";
      this.type = 3;
      getHomeHonorListApi(1, 10000).then((res) => {
        this.linkList = res.rows;
      });
    }
  },
  methods: {
    toLinkPage(item) {
      if (item && item.jumpPage) {
        window.open(item.jumpPage, "_blank");
      }
    },
  },

  computed: {},
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
* {
  padding: 0;
}
.page-head {
  width: 100%;
  height: 100px;
  margin: 100px auto;
  .head-title {
    text-align: center;
    font-size: 36px;
  }
}
.common-block {
  width: 120rem; /* 设置div的宽度 */
  margin: 40px 12rem 10px;
  .link-item:first-child {
    margin-left: 0;
  }
  .link-item {
    width: 28.5rem;
    height: 7rem;
    margin-left: 2rem;
    background-color: #e8e8ea;
    .common-link-item-icon {
      width: 3rem;
      height: 2.7rem;
      margin: 2.1rem 1rem 2rem 9rem;
    }
    .common-link-item-name {
      width: 6.8rem;
      height: 2.4rem;
      font-size: 1.7rem;
      font-weight: 600;
      margin: 2.3rem 1rem 2.3rem 0.1rem;
    }
    .friendship-link-item-icon {
      height: 7.2rem;
    }
    .introduce-link-item-icon {
      height: 120px;
    }
  }
}

.html-block {
  border: 1px solid #f1f1f1;
}
@media only screen and (max-width: 1920px) {
}

@media only screen and (max-width: 1680px) {
}

@media only screen and (max-width: 1440px) {
}

@media only screen and (max-width: 1366px) {
}

@media only screen and (max-width: 1280px) {
} /*>=1280的设备*/

@media only screen and (max-width: 1100px) {
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
}
@media only screen and (min-width: 640px) and (max-width: 767px) {
}

@media only screen and (min-width: 320px) and (max-width: 640px) {
}
</style>
